import { isEmpty } from "lodash";
import { put, call, takeLatest } from "redux-saga/effects";
import { FETCH_SESSION, setSession } from "./actions";
import { fetchSession } from "./request";

export function* fetchUserSession({ payload: subdomain }) {
  try {
    const response = yield call(fetchSession, subdomain, false);
    const { data = {}, error } = response.data;
    if (!error && isEmpty(data)) {
      yield put(setSession(data));
    } else if (error) {
      yield put(setSession({ error }));
    } else {
      yield put(setSession(data));
    }
  } catch (err) {
    yield put(setSession({ error: err.response.data }));
  }
}

export default function* sessionRequestWatcher() {
  yield takeLatest(FETCH_SESSION, fetchUserSession);
}
